<div class="content">
    <div class="description">
        <h1>{{_ss.workShopConfig.site_title}}</h1>
        <p>Actualmente la web está en mantenimiento, vuelve pronto!</p>
    </div>
</div>
